import React from 'react';
import { connect } from "react-redux"
import Header from './Header.js'
import DatePicker from 'react-datepicker2';
import { ProgressSpinner } from 'primereact/progressspinner';

import momentJalaali from 'moment-jalaali';

import Server from './Server.js'


class CreditPrice extends React.Component {

  constructor(props) {
    super(props);

    this.Server = new Server();


    this.state = {
      visibleLoader: true,
      branches: this.props.branches,
      untilDate: momentJalaali(),
      price: -1

    }
  }

  ConvertNumToFarsi(text) {
    var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    if (!text)
      return text;
    return text.toString().replace(/[0-9]/g, function (w) {
      return id[+w]
    });
  }
  componentDidMount() {
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let SCallBack = (response) => {
        this.setState({
          userId: response.data.authData.userId,
        },()=>{
          this.getCreditPayment();
        })
    };
    let ECallBack = (error) => {
      this.setState({
        showLogin: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)

  }
  getCreditPayment() {
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        Gardesh: response.data.result,
        price: response.data.price ? response.data.price.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0",
        visibleLoader: false
      })
    }
    let ECallBack = function (error) {
      that.setState({
        visibleLoader: false
      })
    }
    this.setState({
      visibleLoader: true
    })
    this.Server.send("MainApi/getCreditPayment", { wallet: 'price', limit: 0, username: this.state.userId, fromDate: this.state.fromDate ? this.state.fromDate.local("fa").format("jYYYY/jM/jD") : null, untilDate: this.state.untilDate ? this.state.untilDate.local("fa").format("jYYYY/jM/jD") : null }, SCallBack, ECallBack)

  }
  render() {

    return (
      <div>
        {!this.props.shop &&
          <Header navigation={this.props.navigation} ComponentName='گردش حساب ' goBack={true} />
        }

        <div >
          {this.state.price != -1 &&
            <p style={{textAlign:'center'}}>موجودی اعتبار نقدی : {this.state.price}  ریال</p>

          }

          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, direction: 'rtl', height: 90 }}>
            <DatePicker
              onChange={value => {
                this.setState({ fromDate: value }); setTimeout(() => {
                  if (this.state.visibleLoader)
                    return;
                  if (this.props.shop) {
                    this.getShopCreditPayment();
                  } else {
                    this.getCreditPayment();
                  }
                }, 0)
              }}
              inputReadOnly={true}
              value={this.state.fromDate}
              className="p-inputtext p-component sarv-input"
              isGregorian={false}
              timePicker={false}
              placeholder="از تاریخ"
              persianDigits={false}

            />
            <DatePicker
              inputReadOnly={true}
              onChange={value => {
                this.setState({ untilDate: value }); setTimeout(() => {
                  if (this.state.visibleLoader)
                    return;
                  if (this.props.shop) {
                    this.getShopCreditPayment();
                  } else {
                    this.getCreditPayment();
                  }
                }, 0)
              }}
              value={this.state.untilDate}
              isGregorian={false}
              timePicker={false}
              className="p-inputtext p-component sarv-input"
              placeholder="تا تاریخ"
              persianDigits={false}

            />


          </div>

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>


            <div style={{ backgroundColor: '#fff', width: '100%', textAlign: 'right' }}>
              <div style={{ textAlign: 'right', fontFamily: 'iranyekanwebmedium', marginRight: 5, fontSize: 12, backgroundColor: '#eee', width: '100%' }}>
                تمامی مبالغ به ریال است
          </div>
            </div>

          </div>
          {!this.state.visibleLoader ?
            <div>

              {!this.props.shop ?
                <div>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, backgroundColor: '#cdd8df' }}>
                    <div style={{ width: '20%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>مبلغ</span>
                    </div>
                    <div style={{ width: '15%', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginLeft: 10 }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>فروشگاه</span>
                    </div>
                    <div style={{ width: '15%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>تاریخ</span>
                    </div>
                    <div style={{ width: '15%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>روز</span>
                    </div>
                    <div style={{ width: '15%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>توضیح</span>
                    </div>
                    <div style={{ width: '20%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>وضعیت</span>
                    </div>

                  </div>
                  {this.state.Gardesh && this.state.Gardesh.length > 0 && this.state.Gardesh.map((v, i) => {
                    return (
                      <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: (i % 2 == 0) ? '#fff' : '#eee' }}>
                        <div style={{ width: '20%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.Amount.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                        </div>
                        <div style={{ width: '15%', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginLeft: 10 }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.shop[0] ? v.shop[0].name : '-'}</span>
                        </div>
                        <div style={{ width: '15%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.Date}</span>
                        </div>
                        <div style={{ width: '15%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.Time}</span>
                        </div>
                        <div style={{ width: '20%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.desc}</span>
                        </div>
                        <div style={{ width: '15%', textAlign: 'center' }}>
                          {v.type == 1 ?
                            <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 12, color: 'green' }}><i className="fas fa-plus-circle" /></span>
                            :
                            <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 12, color: 'red' }}><i className="fas fa-minus-circle" /></span>
                          }
                        </div>
                      </div>
                    )
                  })
                  }
                </div>
                :
                <div style={{ textAlign: 'center' }}>
                  <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 18 }}>آخرین تراکنش های حساب </span>
                  <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, backgroundColor: '#cdd8df' }}>
                    <div style={{ width: '20%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>مبلغ</span>
                    </div>
                    <div style={{ width: '20%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{this.props.shop ? "خریدار" : "فروشگاه"}</span>
                    </div>
                    {this.state.branches && this.state.branches.length > 0 &&
                      <div style={{ width: '10%', textAlign: 'center' }}>
                        <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>شعبه</span>
                      </div>
                    }

                    <div style={{ width: '20%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>تاریخ</span>
                    </div>

                    <div style={{ width: '13%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>توضیح</span>
                    </div>
                    <div style={{ width: '10%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>رسید</span>
                    </div>
                    <div style={{ width: '7%', textAlign: 'center' }}>
                      <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>وضعیت</span>
                    </div>


                  </div>
                  {this.state.Gardesh && this.state.Gardesh.length > 0 && this.state.Gardesh.map((v, i) => {
                    return (
                      <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: ((i % 2 == 0) ? '#fff' : '#eee') }}>
                        <div style={{ width: '20%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 14 }}>{v.Amount.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
                        </div>
                        <div style={{ width: '20%', textAlign: 'center' }}>
                          {this.props.shop ?
                            <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.user[0] ? v.user[0].name : '-'}</span>
                            :
                            <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.shop[0] ? v.shop[0].name : '-'}</span>
                          }
                        </div>
                        {this.state.branches && this.state.branches.length > 0 &&
                          <div style={{ width: '10%', textAlign: 'center' }}>
                            <div style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>
                              {this.state.branchNames.filter((item) => { return item._id == v.ShopId })[0] ? this.state.branchNames.filter((item) => { return item._id == v.ShopId })[0].code : ""}
                            </div>
                          </div>
                        }
                        <div style={{ width: '20%', textAlign: 'center' }}>
                          <div style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.Date}</div>
                          <div style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.Time}</div>
                        </div>

                        <div style={{ width: '13%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.desc}</span>
                        </div>
                        <div style={{ width: '10%', textAlign: 'center' }}>
                          <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 11 }}>{v.resCode}</span>
                        </div>
                        {v.username == "system" ?
                          <div style={{ width: '7%', textAlign: 'center' }}>
                            {v.type == 1 ?
                              <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 12, color: 'green' }}><i className="fas fa-plus-circle" /></span>
                              :
                              <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 12, color: 'red' }}><i className="fas fa-minus-circle" /></span>
                            }
                          </div>
                          :
                          <div style={{ width: '7%', textAlign: 'center' }}>
                            <span style={{ textAlign: 'center', fontFamily: 'iranyekanwebmedium', fontSize: 12, color: 'green' }}><i className="fas fa-plus-circle" /></span>
                          </div>
                        }

                      </div>
                    )
                  })
                  }
                </div>
              }

            </div>
            :
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
            </div>
          }
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    systemId: state.systemId,
    creditPrice: state.creditPrice
  }
}
export default connect(mapStateToProps)(CreditPrice)

